import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export const WorkerBadgeIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon
    viewBox="45 -960 960 960"
    style={{
      height: 35,
      width: 35
    }}
    {...props}
  >
    <g>
      <g>
        <path
          d="M234.667-244.667H474V-260q0-17.667-9.167-31.833Q455.667-306 440.667-312q-28.001-10.333-46.834-14.167Q375-330 356-330q-20.333 0-41.5 
        4.5T268.666-312q-15.666 6-24.833 20.167-9.166 14.166-9.166 31.833v15.333Zm330.666-64.667H732v-53.333H565.333v53.333ZM356-362.667q23.333 0 39.666-16.333Q412-395.333 
        412-418.667q0-23.333-16.334-39.666-16.333-16.334-39.666-16.334t-39.667 16.334Q300-442 300-418.667q0 23.334 16.333 39.667 16.334 16.333 39.667 16.333Zm209.333-62H732V-478H565.333v53.333ZM80-80v-600h300.001v-200h199.998v200H880v600H80Zm66.666-66.666h666.668v-466.668H579.999v86.667H380.001v-86.667H146.666v466.668Zm300.001-446.667h66.666v-220.001h-66.666v220.001ZM480-380Z"
        />
      </g>
    </g>
  </SvgIcon>
);
